<div class="report-card">
    <app-report-table
        [columns]="columns"
        [rows]="rows"
        [orgName]="orgName"
        [reportTitle]="reportName"
        [dateSubtitle]="dateRange">
    </app-report-table>

    <div class="report-card-actions">
        <a *ngIf="csvUrl"
           mat-button
           linkButton
           [disableRipple]="true"
           [href]="csvUrl"
           target="_blank" rel="noopener noreferrer">
            Export CSV
        </a>
        <a *ngIf="pdfUrl"
           mat-button
           linkButton
           [disableRipple]="true"
           [href]="pdfUrl"
           target="_blank" rel="noopener noreferrer">
            Save as PDF
        </a>
        <a *ngIf="reportsPageUrl"
           mat-button
           linkButton
           [disableRipple]="true"
           [routerLink]="reportsPageUrl">
            Open in Reports
        </a>
    </div>
</div>
